import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ProfitCenterService } from '../proxy/controlling/controllers/profit-center.service';
FieldBuilder.setNamespace('Controlling');

export const SAPOLDPROFITCENTER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('profitCenterHeaderId', 'Entity.ProfitCenter', ProfitCenterService)
    .displayFromNested('profitCenterHeader.name')
    .sortBy('profitCenterHeader.name')
    .build(),
  FieldBuilder
    .number('profitCenterId', 'Entity.SapOldProfitCenter.ProfitCenterId')
    .required()
    .build(),
  FieldBuilder.text('sapCode', 'Entity.SapOldProfitCenter.SapCode')
    .required()
    .build(),
  FieldBuilder.text('name', 'Entity.SapOldProfitCenter.Name')
    .required()
    .build(),
];

export const SAPOLDPROFITCENTER_CONFIG = {
  entityName: 'SapOldProfitCenter',
  localizationKey: 'Controlling::Entity.SapOldProfitCenter',
  fields: SAPOLDPROFITCENTER_FIELDS,
  permission: 'ControllingSap.SapOldProfitCenters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
